import React from "react";

import { AuthContext, type SessionContext } from "./AuthContext";

export function useSession(): SessionContext {
  const value = React.useContext(AuthContext);
  return value as SessionContext;
}
